import { useEffect, useState } from "react";

export default function useIsTouchDevice() {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    // read isTouchDevice on mount to avoid
    // react hydration mismatch
    setIsTouchDevice(getIsTouchDevice());
  }, []);

  return isTouchDevice;
}

function getIsTouchDevice() {
  return typeof window !== "undefined" && "ontouchstart" in window;
}
